export const initialLoginState = () => ({
  checkLoginLoading: false,
  checkLoginFailure: false,
  checkLoginLoaded: false,
});
